// A sound-shape for a loop card: bar heights (0.12 to 1) drawn from the loop's
// instrument class, varied per loop by a seed from its id. It is a class
// signature, not the loop's real waveform (we have no peak data), so every drum
// card reads as hits, every melody as a phrase, every texture as a swell and
// every sound effect as a riser or an impact.

const hashSeed = (text = '') => {
  let hash = 2166136261;
  for (let index = 0; index < text.length; index += 1) {
    hash ^= text.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
};

const randomFrom = (seed) => {
  let state = seed || 1;
  return () => {
    state = (state + 0x6d2b79f5) | 0;
    let value = Math.imul(state ^ (state >>> 15), 1 | state);
    value = (value + Math.imul(value ^ (value >>> 7), 61 | value)) ^ value;
    return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
  };
};

const clamp = (value) => Math.min(1, Math.max(0.12, value));

export const loopShape = (group, id = '', count = 36) => {
  const random = randomFrom(hashSeed(`${group}:${id}`));
  const phase = random() * Math.PI;
  const waves = 2 + Math.floor(random() * 2);
  const riser = random() > 0.5;
  return Array.from({ length: count }, (_, index) => {
    const t = index / (count - 1);
    const jitter = random();
    switch (group) {
      case 'Drums':
        return clamp(index % 4 === 0 ? 0.82 + 0.18 * jitter : index % 2 === 0 ? 0.42 + 0.22 * jitter : 0.16 + 0.2 * jitter);
      case 'Textures':
        return clamp(0.34 + 0.26 * Math.sin(t * Math.PI) + 0.08 * jitter);
      case 'Sound FX':
        return clamp(riser ? 0.14 + 0.86 * Math.pow(t, 2.2) + 0.06 * jitter : 1 - 0.85 * Math.pow(t, 0.55) + 0.06 * jitter);
      default:
        return clamp(0.32 + 0.48 * Math.abs(Math.sin(t * Math.PI * waves + phase)) + 0.16 * jitter);
    }
  });
};
